import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {MyserviceService} from '../myservice.service';
import {Router} from '@angular/router';
@Component({
  selector: 'app-adminlogin',
  templateUrl: './adminlogin.component.html',
  styleUrls: ['./adminlogin.component.css'],
    providers:[MyserviceService],
})
export class AdminloginComponent implements OnInit {

  loginForm:FormGroup;
  constructor(private fb: FormBuilder,private router:Router,private serv:MyserviceService) { }
  ngOnInit(): void {
    this.loginForm=this.fb.group({
      username:[null,[Validators.required,Validators.minLength(8)]],
      password:[null,[Validators.required]]
    });
  }
  login_data={
    username:'',
    password:''
  }
  val:boolean=false;
  user:any;
  submit(){
    console.log(this.loginForm);
    this.login_data={
      username:this.loginForm.controls.username.value,
      password:this.loginForm.controls.password.value
    };
    if((this.login_data.password=='isu@1424')&&(this.login_data.username=='isu@1424')){
      this.val=false;
      localStorage.setItem('log','true');
      localStorage.setItem('admin','true');
      localStorage.setItem('loginUser',JSON.stringify(this.login_data));
      alert("you are logged in");
      this.router.navigate(['admin']);

    }
    else{
      this.val=true;
      console.log("Error");
    }

  }

}
